import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class TurnoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let turno = model;

        if (!turno.descricao) {
            refs.descricaoInput.focusedOut = true;
            this.showMessage(new Message('alert', 'msg-descricao-turno', true));
            validated = false;
        }
        
        return validated;
    }

}